import withAllowOrderMakePayment from 'HOCs/fx/withAllowOrderMakePayment';
import withCheckMakePaymentExpired from 'HOCs/fx/withCheckMakePaymentExpired';
import withDetectPaymentMethodOnChange from 'HOCs/fx/withDetectPaymentMethodOnChange';
import withFxMakePayment from 'HOCs/fx/withFxMakePayment';
import withFxMakePaymentAsGuest from 'HOCs/fx/withFxMakePaymentAsGuest';
import withDiscountAutoApply from 'HOCs/withDiscountAutoApply';
import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import DiscountsDrawer from 'components/Discount/components/DiscountsDrawer';
import FormPaymentByDeposit from 'components/FormAddTransaction/components/FormPaymentByDeposit';
import FormPaymentByDepositMobile from 'components/FormAddTransaction/components/FormPaymentByDeposit/mobile/ver2';
import ButtonCommon from 'components/common/ButtonCommon';
import FadeSectionWrap from 'components/common/FadeSectionWrap';
import InformPopup from 'components/common/InformPopup';
import { checkFormInputValidation } from 'components/common/func';
import CalculatorForm from 'components/fx/FxFormAddTransaction/CalculatorForm';
import {
  ActionWrapper,
  ButtonCommonWrap,
  DiscountWrapper,
} from 'components/fx/FxFormAddTransaction/ConfirmInformation';
import FormTransactionDetails from 'components/fx/FxFormAddTransaction/FormTransactionDetails';
import FormTransactionSummary from 'components/fx/FxFormAddTransaction/FormTransactionSummary';
import FxMakePayment from 'components/fx/FxFormAddTransaction/FxMakePayment';
import OrderReceiptDetails from 'components/fx/FxFormAddTransaction/OrderReceiptDetails';
import { NextWrap } from 'components/fx/FxFormAddTransaction/PaymentMethod';
import TransactionSummary from 'components/fx/FxFormAddTransaction/TransactionSummary';
import BodySectionHeader from 'components/fx/components/BodySectionHeader';
import FormTransactionReceiptDetails from 'components/fx/components/FormTransactionDetails';
import {
  DESKTOP_MIN_WIDTH,
  FX_TRANSACTION_ADD_PREFIX,
  HOME_URL,
  NAV_MENUS_UNAUTHENTICATE,
  ORDER_EMAIL,
  RESET_PAYMENT_BY_DEPOSIT_STORE,
  SCREEN_ID_EXCHANGE_STEP_6,
  THROTTLE_SUBMIT_SEC,
} from 'constants';
import {
  AS_GUEST,
  FX_ADD_TRANSACTION_UPLOAD_ID_DOCUMENT_UPLOAD_DRIVER_LICENCE_FIELDS,
  FX_ADD_TRANSACTION_UPLOAD_ID_DOCUMENT_UPLOAD_PASSPORT_FIELD,
  FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_FRONT_NAME,
  FX_ADD_TRANSACTION_UPLOAD_ID_PASSPORT_NAME,
  RESET_FX_ADD_TRANSACTION_DOCUMENT_UPLOAD,
} from 'constants/fx';
import Cookies from 'helpers/cookies';
import { checkMaintenance } from 'helpers/maintenance';
import useFxAddTransaction, {
  FX_MAKE_PAYMENT_KEY,
} from 'hooks/fx/useFxAddTransaction';
import useFxDiscount from 'hooks/fx/useFxDiscount';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useFxPayment from 'hooks/fx/useFxPayment';
import useAuth from 'hooks/useAuth';
import useAutoShowEventModal from 'hooks/useAutoShowEventModal';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useScrollIntoViewDelay from 'hooks/useScrollIntoViewDelay';
import useScrollToTop from 'hooks/useScrollToTop';
import useTheme from 'hooks/useTheme';
import useThrottle from 'hooks/useThrottle';
import { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import UploadDetails from './UploadDetails';

const FxMakePaymentExtend = withFxMakePayment(
  withAllowOrderMakePayment(
    withCheckMakePaymentExpired(
      withDetectPaymentMethodOnChange(withFxMakePaymentAsGuest(FxMakePayment))
    )
  )
);

const DiscountsDrawerExt = withDiscountAutoApply(DiscountsDrawer);

const initialField = RESET_FX_ADD_TRANSACTION_DOCUMENT_UPLOAD;
const initialFormCard = RESET_PAYMENT_BY_DEPOSIT_STORE;

const SCREEN_ID = SCREEN_ID_EXCHANGE_STEP_6;

const DocumentUpload = ({
  handleOnToggleCancelPopup,
  handleOnViewPickupLocation,
}) => {
  const { t, locate } = useLang();
  const { theme } = useTheme();
  const { isMobile, isTablet, isDesktop } = useDetectDevice();
  const { token } = useAuth();
  const navigate = useNavigate();
  const { throttle, isThrottleLocked, resetThrottle } =
    useThrottle(THROTTLE_SUBMIT_SEC);

  const [information, setInformation] = useState(initialField);
  const [validation, setValidation] = useState(initialField);
  const [isShowDiscountInvalidPopup, setShowDiscountInvalidPopup] =
    useState(false);
  const [isShowTransactionDetails, setShowTransactionDetails] = useState(false);
  const [isShowFormPaymentByDeposit, setShowFormPaymentByDeposit] =
    useState(false);
  const [transactionInformation, setTransactionInformation] = useState(null);
  const [cardInformation, setCardInformation] = useState(initialFormCard);
  const [cardValidation, setCardValidation] = useState(initialFormCard);
  const [errorCode, setErrorCode] = useState('');
  const [isShowReceiptDetails, setShowReceiptDetails] = useState(false);
  const [failedDiscount, setFailedDiscount] = useState(null);

  const { isDriverLicenceSelected } = information;

  const {
    addTransactionCurrentStep: currentStep,
    setAddTransactionCurrentStep,
    transactionDetails,
    setDocumentUpload,
    discountApplied,
    discountsAvailable,
    discountsInactive,
    discountDefault,
    isHideDiscountSection,
    currencyOrders,
    confirmInformationEmail,
    isForceShowReceiptDetailsScreen,
    isPaymentSuccessfully,
  } = useFxFormAddTransactionStore();
  const {
    isDisabled,
    isMakePayment,
    orderRef,
    isCreateNewTran,
    getTitleBodySection,
    isFxAsGuest,
    mpmTimestamp,
  } = useFxAddTransaction();
  const { handleOnPayProcess, handleOnPayByDepositProcess } = useFxPayment();
  const { fetchFxDiscountsAvailable, handleRemoveFxDiscountApplied } =
    useFxDiscount();

  const isNextDisabled = false;

  const getDocuments = (information) =>
    Object.keys(information)
      ?.map((key) => information[key]?.document)
      ?.filter(Boolean);

  useScrollToTop();

  // scroll to calculator form
  const validRef = useRef(null);
  useScrollIntoViewDelay(validRef, validRef, []);

  useEffect(() => {
    const isAllowFetchDiscountsAvailable =
      !isDisabled &&
      currencyOrders?.length &&
      isEmpty(discountApplied) &&
      isEmpty(discountsAvailable) &&
      isEmpty(discountsInactive);
    if (isAllowFetchDiscountsAvailable) {
      console.log(`⭐ DocumentUpload 👉 isAllowFetchDiscountsAvailable ↩`);
      fetchFxDiscountsAvailable({
        token,
      });
    }
  }, [
    isDisabled,
    currencyOrders,
    discountApplied,
    discountsAvailable,
    discountsInactive,
  ]);

  // Memoized so its identity is stable across renders. withDiscountAutoApply's
  // default-auto-apply effect lists this callback (via onApplyError) as a
  // dependency; a fresh inline function every render made that effect re-fire
  // after every failure -> state update -> re-render, re-triggering the same
  // discount-apply call in a loop. Also records the failed discount so it can
  // be passed back in via failedDiscountRecovery, which is what actually gates
  // the HOC's auto-apply effect (hasResolvedFailure) from re-arming.
  //
  // withDiscountAutoApply's own wrapper already resolves `item` to
  // `item || discountDefault` before invoking this for the auto-apply path
  // (see withDiscountAutoApply.jsx), so `item` arrives non-empty there. The
  // manual discount-selection path (drawer/modal) calls onApplyError(errorCode)
  // with no item, since neither checkDiscountAppliedValid's nor
  // checkFxDiscountAppliedValid's catch forwards the attempted discount. Do
  // NOT fall back to discountDefault here: that would misattribute a failed
  // manual (non-default) discount as the default one, wrongly blocking the
  // default discount's own auto-apply gate for the rest of the session.
  const handleApplyDiscountError = useCallback(
    (errorCode, item) => {
      setErrorCode(errorCode);
      if (isEmpty(discountDefault)) {
        setShowDiscountInvalidPopup(true);
      }
      setFailedDiscount(item || null);
    },
    [discountDefault],
  );

  // A later legitimate default-discount change (e.g. from an amount edit)
  // should not stay permanently blocked by a stale failure marker from a
  // previous default.
  useEffect(() => {
    setFailedDiscount(null);
  }, [discountDefault?.code]);

  const renderDiscountSection = () => {
    if (isHideDiscountSection) return null;
    return (
      <DiscountWrapper>
        <DiscountsDrawerExt
          onApplyError={handleApplyDiscountError}
          isFx={true}
          // FX has no first-landing "settling" transient like TO step 2, and
          // isHideDiscountSection already gates the empty/no-default case, so
          // mark the result ready. Without it the drawer's inline display gate
          // (isDiscountResultReady falsy + not loading) hides the applied
          // section even after a successful default apply.
          isDiscountResultReady={true}
          // Gates withDiscountAutoApply's hasResolvedFailure: once a default
          // apply has failed once, this stops the auto-apply effect from
          // re-arming and looping the same failed apply call.
          failedDiscountRecovery={{ discount: failedDiscount, errorCode }}
        />
      </DiscountWrapper>
    );
  };

  const handleOnCloseFormPaymentByDeposit = () => {
    setShowFormPaymentByDeposit(false);

    setCardValidation(initialFormCard);

    Cookies.set(FX_MAKE_PAYMENT_KEY, true);

    resetThrottle();

    navigate(
      `${FX_TRANSACTION_ADD_PREFIX}?as=${AS_GUEST}&orderRef=${
        transactionInformation?.orderRef || orderRef
      }&email=${confirmInformationEmail}${
        mpmTimestamp ? `&token=${mpmTimestamp}` : ''
      }`
    );
  };

  const handleOnCloseTransactionDetailsPopup = () => {
    setShowTransactionDetails(false);
  };

  const handleBackStep = () => {
    setDocumentUpload(information);
    setAddTransactionCurrentStep(currentStep - 1);
  };
  const handleNextStep = async () => {
    let newInformation = { ...information };
    let newValidation = { ...validation };

    const documents = getDocuments(information);

    delete newInformation['isDriverLicenceSelected'];
    delete newValidation['isDriverLicenceSelected'];

    if (isDriverLicenceSelected) {
      delete newInformation[FX_ADD_TRANSACTION_UPLOAD_ID_PASSPORT_NAME];
      delete newValidation[FX_ADD_TRANSACTION_UPLOAD_ID_PASSPORT_NAME];
    }

    if (!isDriverLicenceSelected) {
      delete newInformation[
        FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_FRONT_NAME
      ];
      delete newValidation[
        FX_ADD_TRANSACTION_UPLOAD_ID_DRIVER_LICENCE_FRONT_NAME
      ];
    }

    const isAllowSubmit = isMakePayment
      ? true
      : Object.values(newInformation).every((value) => value) &&
        Object.values(newValidation).every((value) => !value) &&
        documents?.length;

    if (isAllowSubmit) {
      try {
        if (isCreateNewTran) {
          setDocumentUpload(information);
        }
        setShowTransactionDetails(true);
      } catch (error) {
        checkMaintenance(error);
        console.error(error?.message);
      }
    }

    if (!isAllowSubmit) {
      let fields = [];

      if (isDriverLicenceSelected) {
        fields =
          FX_ADD_TRANSACTION_UPLOAD_ID_DOCUMENT_UPLOAD_DRIVER_LICENCE_FIELDS;
      }

      if (!isDriverLicenceSelected) {
        fields = FX_ADD_TRANSACTION_UPLOAD_ID_DOCUMENT_UPLOAD_PASSPORT_FIELD;
      }

      fields.forEach((field) => {
        newValidation = checkFormInputValidation(
          information[field.name],
          field,
          newValidation
        );
      });

      setValidation(newValidation);
    }
  };
  const renderCalculatorFormMobile = () => {
    if (isDesktop) return null;
    if (isMakePayment)
      return (
        <CalculatorForm
          ref={validRef}
          isCalculatorFormDetailsAccordion={true}
          isCalculatorFormAccordionExpandable={true}
          isExpandDefault={false}
        />
      );
    return (
      <CalculatorForm
        ref={validRef}
        isCalculatorFormAccordion={true}
        handleOnViewPickupLocation={handleOnViewPickupLocation}
      />
    );
  };
  const handleOnPay = () => {
    throttle(() => {
      handleOnPayProcess({
        transactionInformation,
        setTransactionInformation,
        setShowTransactionDetails,
        setShowFormPaymentByDeposit,
        setErrorCode,
        setShowDiscountInvalidPopup,
        resetThrottle,
      });
    });
  };
  const renderActionsButton = () => {
    if (isMakePayment)
      return (
        <NextWrap>
          {renderCalculatorFormMobile()}
          <ActionWrapper>
            <ButtonCommon
              value={t('button_pay')}
              color="var(--c-primary)"
              background="var(--bg-primary)"
              isFill={true}
              styles={{
                margin: '0px',
                width: isDesktop ? '200px' : '100%',
              }}
              onClick={handleOnPay}
              isDisabled={isThrottleLocked}
              isUseKeyDown={!isNextDisabled}
            />
          </ActionWrapper>
        </NextWrap>
      );
    return (
      <NextWrap>
        {renderCalculatorFormMobile()}
        <ActionWrapper>
          <ButtonCommonWrap>
            <ButtonCommon
              value={t('button_back')}
              onClick={handleBackStep}
              styles={{
                margin: '0px',
                width: !isDesktop && '100%',
              }}
              color="var(--ds-c-blue)"
              background="var(--ds-c-white)"
              borderNameVariable={isDesktop && '--border-filter'}
              isFill={false}
            />
          </ButtonCommonWrap>
          <ButtonCommon
            value={t('button_review_and_pay')}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
            styles={{
              margin: '0px',
              width: isDesktop ? '150px' : '50%',
            }}
            onClick={handleNextStep}
            isDisabled={false}
            isUseKeyDown={!isNextDisabled}
          />
        </ActionWrapper>
      </NextWrap>
    );
  };

  const handleCloseDiscountInvalidPopup = () => {
    setShowDiscountInvalidPopup(false);

    if (isDesktop && !errorCode) {
      const discountDrawerCloseBtn =
        document.getElementsByClassName('btn-close')[0];

      if (discountDrawerCloseBtn) {
        discountDrawerCloseBtn.click();
      }
    }

    if (errorCode) {
      setErrorCode('');

      fetchFxDiscountsAvailable({
        token,
      });
    }

    if (isShowTransactionDetails) {
      handleRemoveFxDiscountApplied();
      handleOnCloseTransactionDetailsPopup();
      resetThrottle();
    }
  };
  const renderDiscountInvalidPopup = (isOpen) => {
    return (
      <InformPopup
        isOpen={isOpen}
        imageSrc={NoticeIcon}
        imagesStyles={{
          width: '75px',
          height: '60px',
          marginBottom: '8px',
        }}
        text={t('label_important')}
        content={t(
          errorCode
            ? `popup_discount_invalid_error_msg_${errorCode.toLowerCase()}`
            : `popup_discount_invalid_error_msg`
        )}
        alignContent="center"
        buttonLabel2={t('button_ok')}
        onClick={handleCloseDiscountInvalidPopup}
        isBackdropOverlap={true}
        zIndexBackdropOverlap={1055}
      />
    );
  };

  const handleOnBackToTransactionSummary = () => {
    if (!isFxAsGuest) return;
    setShowReceiptDetails(false);
  };
  const handleOnNextToViewReceiptDetails = () => {
    if (!isFxAsGuest) return;
    setShowReceiptDetails(true);
  };
  const handleOnBackToHome = () => {
    if (!isFxAsGuest) return;
    Cookies.remove(FX_MAKE_PAYMENT_KEY);
    Cookies.remove(ORDER_EMAIL);
    window.location.href = `${HOME_URL[theme]}${NAV_MENUS_UNAUTHENTICATE[1].href}?lang=${locate}`;
  };

  useAutoShowEventModal({
    screenId: SCREEN_ID,
    params: [],
    modalStyles: {},
    modalOptions: {},
    conditions: [
      isForceShowReceiptDetailsScreen,
      isShowReceiptDetails,
      isPaymentSuccessfully,
      isMakePayment,
    ],
  });

  if (isEmpty(currencyOrders)) return null;
  if (isForceShowReceiptDetailsScreen)
    return <OrderReceiptDetails handleOnBackToHome={handleOnBackToHome} />;
  if (isShowReceiptDetails)
    return (
      <>
        {!isEmpty(transactionDetails) && (
          <FormTransactionReceiptDetails
            isOpen={!isEmpty(transactionDetails)}
            onClose={null}
            onClick={handleOnBackToTransactionSummary}
            isReceipt={true}
            transactionDetails={transactionInformation}
          />
        )}
      </>
    );
  if (isPaymentSuccessfully)
    return (
      <TransactionSummary
        transactionInformation={transactionInformation}
        cardInformation={cardInformation}
        handleOnNextToViewReceiptDetails={handleOnNextToViewReceiptDetails}
        handleOnBackToHome={handleOnBackToHome}
      />
    );
  if (isMakePayment)
    return (
      <FadeSectionWrap>
        {isShowTransactionDetails && (
          <FormTransactionDetails
            isOpen={isShowTransactionDetails}
            onClose={handleOnCloseTransactionDetailsPopup}
          />
        )}
        {isShowFormPaymentByDeposit && (
          <>
            {isMobile || isTablet ? (
              <FormPaymentByDepositMobile
                isFx={true}
                isFxAsGuest={isFxAsGuest}
                isOpen={isShowFormPaymentByDeposit}
                transactionInformation={transactionInformation}
                cardInformation={cardInformation}
                setCardInformation={setCardInformation}
                cardValidation={cardValidation}
                setCardValidation={setCardValidation}
                onClose={handleOnCloseFormPaymentByDeposit}
                onClick={(urlRedirect) =>
                  handleOnPayByDepositProcess(
                    urlRedirect,
                    transactionInformation,
                    handleOnCloseFormPaymentByDeposit
                  )
                }
              />
            ) : (
              <FormPaymentByDeposit
                isFx={true}
                isFxAsGuest={isFxAsGuest}
                isOpen={isShowFormPaymentByDeposit}
                transactionInformation={transactionInformation}
                cardInformation={cardInformation}
                setCardInformation={setCardInformation}
                cardValidation={cardValidation}
                setCardValidation={setCardValidation}
                onClose={handleOnCloseFormPaymentByDeposit}
                onClick={(urlRedirect) =>
                  handleOnPayByDepositProcess(
                    urlRedirect,
                    transactionInformation,
                    handleOnCloseFormPaymentByDeposit
                  )
                }
              />
            )}
          </>
        )}
        {isShowDiscountInvalidPopup &&
          renderDiscountInvalidPopup({
            isOpen: isShowDiscountInvalidPopup,
          })}

        <BodySectionHeader
          titleBodySection={getTitleBodySection()}
          titleSection={t('add_transaction_title_payment_method')}
          CalculatorComponent={isDesktop && <CalculatorForm />}
          onToggleCancelPopup={handleOnToggleCancelPopup}
          onViewPickupLocation={handleOnViewPickupLocation}
          onViewOrderDetails={handleNextStep}
        />
        <FxMakePaymentExtend
          renderActionsButton={renderActionsButton}
          renderDiscountSection={renderDiscountSection}
          onPayProcess={handleOnPay}
        />
      </FadeSectionWrap>
    );
  return (
    <>
      {isShowTransactionDetails && (
        <FormTransactionSummary
          isOpen={isShowTransactionDetails}
          onClose={handleOnCloseTransactionDetailsPopup}
          onClick={handleOnPay}
          isOnClickLocked={isThrottleLocked}
        />
      )}
      {isShowFormPaymentByDeposit && (
        <>
          {isMobile || isTablet ? (
            <FormPaymentByDepositMobile
              isFx={true}
              isFxAsGuest={isFxAsGuest}
              isOpen={isShowFormPaymentByDeposit}
              transactionInformation={transactionInformation}
              cardInformation={cardInformation}
              setCardInformation={setCardInformation}
              cardValidation={cardValidation}
              setCardValidation={setCardValidation}
              onClose={handleOnCloseFormPaymentByDeposit}
              onClick={(urlRedirect) =>
                handleOnPayByDepositProcess(
                  urlRedirect,
                  transactionInformation,
                  handleOnCloseFormPaymentByDeposit
                )
              }
            />
          ) : (
            <FormPaymentByDeposit
              isFx={true}
              isFxAsGuest={isFxAsGuest}
              isOpen={isShowFormPaymentByDeposit}
              transactionInformation={transactionInformation}
              cardInformation={cardInformation}
              setCardInformation={setCardInformation}
              cardValidation={cardValidation}
              setCardValidation={setCardValidation}
              onClose={handleOnCloseFormPaymentByDeposit}
              onClick={(urlRedirect) =>
                handleOnPayByDepositProcess(
                  urlRedirect,
                  transactionInformation,
                  handleOnCloseFormPaymentByDeposit
                )
              }
            />
          )}
        </>
      )}
      {isShowDiscountInvalidPopup &&
        renderDiscountInvalidPopup({
          isOpen: isShowDiscountInvalidPopup,
        })}

      <BodySectionHeader
        titleBodySection={getTitleBodySection()}
        titleSection={t('fx_add_transaction_identifications')}
        CalculatorComponent={isDesktop && <CalculatorForm />}
        onToggleCancelPopup={handleOnToggleCancelPopup}
        onViewPickupLocation={handleOnViewPickupLocation}
      />
      <DocumentUploadStyled>
        <UploadDetails
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
        {renderDiscountSection()}
        {renderActionsButton()}
      </DocumentUploadStyled>
    </>
  );
};

const DocumentUploadStyled = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: -8px;
  padding-inline: 0px;
  padding-bottom: 204px;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 676px;
    margin-top: 0px;
    padding-inline: 0px;
    padding-bottom: unset;
  }
`;

export default DocumentUpload;
